import React from 'react';
import { FormInput } from '../FormInput/FormInput';
import { Icon } from '../Icon/Icon';
import './PasswordInput.scss';

export const PasswordInput = ({
  id,
  value,
  onChange,
  onBlur,
  placeholder = 'Password',
  disabled = false,
  error = '',
  showErrorMsg = true,
  focusVariant = 'primary',
  inputProps = {},
}) => {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div className={`password-input ${error ? 'password-input--error' : ''}`}>
      <FormInput
        id={id}
        label=''
        type={showPassword ? 'text' : 'password'}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        error={error}
        showErrorMsg={showErrorMsg}
        focusVariant={focusVariant}
        inputProps={inputProps}
      />

      <button
        type='button'
        className='password-input__toggle'
        aria-label={showPassword ? 'Hide password' : 'Show password'}
        onClick={() => setShowPassword((v) => !v)}
        disabled={disabled}
      >
        {showPassword ? (
          <Icon name='Show' size='sm' />
        ) : (
          <Icon name='Hide' size='sm' />
        )}
      </button>
    </div>
  );
};
